import React, { useState, useEffect } from 'react';
import { compose } from 'ramda';
import styleFile from './MBoxDeepLink.js';
import moment from 'moment';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import { withContent } from '@synergycms_core/components/providers/translateProvider';
import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import { RichText, Image, Button } from '@synergycms_core/components/generic';
import Modal from '@synergycms_core/components/generic/Modal';

export default compose(
  PropertyManager([
    'reservation',
    'hotelInfo',
    'reservationBlocks',
    'hotelAvail',
    'langCode',
    'mboxLinkConfig'
  ]),
  withThemeJSS({ styleFile, link: true, displayName: 'MBoxDeepLink' }),
  withContent('i18n')
)((props) => {
  const { config, theme, content } = props,
    { classes } = theme.styles,
    { reservation, hotelInfo, reservationBlocks, hotelAvail, langCode, mboxLinkConfig } = config;
  let totalAdults = 0;
  let totalChilds = 0;
  const [showModal, setShowModal] = useState(false);
  const [modalDismissed, setModalDismissed] = useState(false);

  reservationBlocks.forEach((block) => {
    const roomAvail = hotelAvail && hotelAvail.getIn([block.get('idx') - 1, block.get('room_id')]);
    totalAdults += roomAvail && roomAvail.get('adults', 0);
    totalChilds += roomAvail && roomAvail.get('childs', 0) + roomAvail.get('babies', 0);
  });

  /* timer for modal, show after 3 seconds */
  useEffect(() => {
    if (modalDismissed) return;
    const timer = setTimeout(() => {
      setShowModal(true);
    }, 3000);
    return () => clearTimeout(timer);
  }, [modalDismissed]);
  const click_id_modal = 'td-mbox-purchase-00';
  const click_id_banner = 'td-mbox-purchase-01';

  const buildUrl = () => {
    const baseUrl = mboxLinkConfig.getIn(['mboxUrl', langCode, 'translatable_value']);
    const urlParams = mboxLinkConfig.getIn(['params'], false);
    const paramsArray = urlParams && urlParams.match(/[\w]+/g);
    const url = new URL(baseUrl);

    if (paramsArray) {
      const defaultParams = {
        hotelName: hotelInfo.get('name'),
        hotelLongitude: hotelInfo.get('longitude'),
        hotelLatitude: hotelInfo.get('latitude'),
        distribution: totalAdults + '~~' + totalChilds,
        startDate: moment(reservation.get('checkin'), 'YYYY-MM-DD').format('DD/MM/YYYY'),
        endDate: moment(reservation.get('checkout'), 'YYYY-MM-DD').format('DD/MM/YYYY')
      };
      paramsArray
        .filter((param) => defaultParams.hasOwnProperty(param))
        .forEach((param) => url.searchParams.set(param, defaultParams[param]));
    }
    return url;
  };

  const handleButtonClick = (isModal = false) => {
    const urlDeepLink = buildUrl();
    if (!isModal) {
      urlDeepLink.searchParams.set('utm_source', 'ehc');
      urlDeepLink.searchParams.set('utm_medium', 'web');
    }
    window.open(urlDeepLink.toString(), '_blank', 'noopener,noreferrer');
  };

  /* deep link content */
  const DeepLinkContent = ({ isModal = false }) => (
    <div
      className={[theme.computedInnerStyle, classes.deepLinkContainer, isModal ? classes.styleForModal : ''].join(' ')}>
      {/* close button for Modal */}
      {isModal && (
        <Button
          innerStyle={classes.closeButton}
          onClick={() => {
            setShowModal(false);
            setModalDismissed(true);
          }}
          icon={{ unicodeContent: 'e001' }}
          translate={true}
          ariaLabel={'_%cerrar%_'}
        />
      )}
      {/* banner */}
      <div className={classes.deepLinkBanner}>
        {/* box 1 */}
        <div className={classes.deepLinkBox1}>
          {/* title */}
          <div className={classes.deepLinkTitle}>
            <RichText
              innerStyle={['mainColor']}
              translate={true}
              ucFirst={true}
              dangerouslySetInnerHTML={'_%traslados, coche, actividades... Resérvalo antes de viajar%_'}
            />
          </div>
          {/* images */}
          <div className={classes.deepLinkImages}>
            <Image src={content.t('_%mbox_image_01%_')} loading={'lazy'} />
            <Image src={content.t('_%mbox_image_02%_')} loading={'lazy'} />
            <Image src={content.t('_%mbox_image_03%_')} loading={'lazy'} />
          </div>
        </div>
        {/* box 2 */}
        <div className={classes.deepLinkBox2}>
          {/* button */}
          <div className={classes.deepLinkBtn}>
            {/* href deeplink */}
            <Button
              id={isModal ? click_id_modal : click_id_banner}
              onClick={() => handleButtonClick(isModal)}
              richText={{
                innerStyle: ['uppercase'],
                translate: true,
                text: '_%añadir servicios%_'
              }}
              innerStyle={[classes.deepLinkBtnHref]}
            />
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <>
      <DeepLinkContent />
      {showModal && (
        <Modal
          modalStyle={classes.mBoxModalStyle}
          contentStyle={classes.modalContent}
          instantToggle={true}
          popover={<DeepLinkContent isModal />}
          typeModal={'magicBoxModal'}
          filterModal={true}
        />
      )}
    </>
  );
});
